<template>
  <div>
    <div class="flex flex-col flex-no-shrink flex-no-grow text-grey-darkest border-light-grey border-b border-solid text-xs" :class="isView ? 'border-none' : ''">
      <div class="grid_container text-sm">
        <div>
          <div v-if="doc.spc_consultation_name" class="item truncate capitalize" :title="doc.name">{{`Attachments of ${doc.spc_consultation_name} consultation`}}</div>
          <div v-else class="item truncate capitalize" :title="doc.name">{{doc.uploaded_by || 'Unknown'}}</div>
          <div class="item text-grey" style="margin-top: 4px">{{doc.date | formatDateWithoutTime}}</div>
        </div>
        <div class="item capitalize">{{doc.category}}</div>
        <div></div>
        <div @click="showResultsModal(doc)" v-bind:class="[((isView === true)) ? 'btn fas fa-chevron-down text-grey bg-grey-lightest rounded-full' : 'btn fas fa-chevron-right text-grey bg-grey-lightest rounded-full']"></div>
      </div>
      <div v-if="isView" class="flex flex-row h-8 bg-grey-extralight border-solid border-b border-grey-lightest justify-between mx-3" style="border-radius: 3px 3px 0 0; font-size: .875rem">
        <div class="flex flex-row justify-between">
          <div @click="setActiveResults('results')" v-bind:class="[activeResults === 'results' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer ml-2 mt-2 mr-4">Results</div>
          <div @click="setActiveResults('notes')" v-bind:class="[activeResults === 'notes' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer mt-2 mr-4">Notes</div>
          <div @click="setActiveResults('reports')" v-bind:class="[activeResults === 'reports' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer mt-2 ">Reports</div>
        </div>
        <div @click="showFullViewModal(doc)" class="text-grey text-sm cursor-pointer hover:text-blue align-right mt-1 mr-2 flex flex-row"><img src="../../assets/full View.svg" class="mr-2"/><span class="self-center">Full View</span></div>
      </div>
      <div v-show="(isView === true)" class="pb-0 pl-3 mr-3 flex flex-col overflow-y-auto" style="min-width: 26rem; max-width: 62rem;max-height: 11.5rem; font-size: .875rem">
        <div v-show="activeResults === 'results'" v-if="(doc.category === 'Prescription')" class="bg-grey-extralight overflow-y-auto p-2" style="border-radius: 0 0 3px 3px">No Results</div>
        <div v-show="activeResults === 'results'" v-else-if="(doc.health_assessment_status === null)" class="bg-grey-extralight overflow-y-auto p-2" style="border-radius: 0 0 3px 3px">No Results</div>
        <div v-show="activeResults === 'results'" v-else-if="(doc.health_assessment_status !== 'done') && (doc.health_assessment_status !== undefined)" class="bg-grey-extralight overflow-y-auto p-2" style="border-radius: 0 0 3px 3px">Lab results digitization under {{doc.health_assessment_status}}</div>
        <div v-show="activeResults === 'results'" v-else-if="doc.lab_results && doc.lab_results.length<1" class="bg-grey-extralight overflow-y-auto p-2" style="border-radius: 0 0 3px 3px">No Results</div>
        <div v-show="activeResults === 'results'" v-else-if="(doc.health_assessment_status === 'done')" v-for="(lab_result, labIndex) in doc.lab_results" :key="labIndex" class="bg-grey-extralight flex flex-col border-solid border-grey-lightest" style="border-radius: 0 0 3px 3px; color: #324467">
          <div v-if="lab_result.name === null" class="font-semibold py-3 px-2">No Results</div>
          <div v-else-if="lab_result.name === ''" class="font-semibold py-3 px-2">No Results</div>
          <div v-else-if="lab_result.name" class="font-semibold py-3 px-2">{{lab_result.name}}</div>
          <div></div>
          <div v-for="(result, index) in lab_result.results" :key="index" class="text-grey flex flex-row justify-between overflow-y-auto" style="color: #324467">
            <div class="pb-3 px-2">{{result.test_component_name}}</div>
            <div :class="result.color" class="pb-3 px-2">{{result.result}}</div>
          </div>
        </div>
        <div v-show="activeResults === 'notes'" v-if="(doc.category === 'Prescription')" class="bg-grey-extralight overflow-y-auto p-2" style="border-radius: 0 0 3px 3px; color: #324467">No Notes</div>
        <div v-show="activeResults === 'notes'" v-else-if="doc.notes && doc.notes.length<1" class="bg-grey-extralight overflow-y-auto p-2" style="border-radius: 0 0 3px 3px; color: #324467">No Notes</div>
        <div v-show="activeResults === 'notes'" v-else v-for="(note, index) in doc.notes" :key="index" class="bg-grey-extralight flex flex-col border-radius-3 border-solid border-grey-lightest" style=" color: #324467">
          <div v-if="hasHTML(note.title)" class="font-semibold py-3 px-2" v-html="note.title"></div>
          <div v-else class="font-semibold py-3 px-2">{{ note.title }}</div>
          <div v-if="hasHTML(note.description)" class="pb-3 px-2 text-grey" v-html="note.description"></div>
          <div v-else class="pb-3 px-2 text-grey">{{ note.description }}</div>
        </div>
        <div v-show="activeResults === 'reports'" class="bg-grey-extralight border-solid border-grey-lightest overflow-y-auto" style="max-height: 155px; border-radius: 0 0 3px 3px; color: #324467" >
          <div class="m-2" v-if="(doc.reports === undefined) && (doc.category === 'Prescription')" @click="getDocument(doc.category, doc.id)" data-toggle="modal" data-target="#myModal"><span class="text-blue font-semibold cursor-pointer">{{doc.name}}</span></div>
          <div v-else-if="doc.reports && doc.reports.length<1" class="m-2 text-sm">No Reports</div>
          <div v-else v-for="(report, index) in doc.reports" :key="index" @click="getDocument(report.category, report.id)" data-toggle="modal" data-target="#myModal" class="justify-between m-2 text-blue font-semibold cursor-pointer">{{report.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import documents from '../../api/customer/document'
export default {
  props: ['doc'],
  data () {
    return {
      activeResults: 'results',
      isView: false,
      docIndex: null,
      showFullView: false,
      document: null
    }
  },
  methods: {
    getDocument: function (reportType, reportId) {
      documents.fetch(reportType, reportId).then(response => {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank')
        } else {
          this.$toast.open({
            message: 'Error fetching data',
            type: 'error',
            position: 'top-right'
          })
        }
      }, response => {
      })
    },
    setActiveResults: function (resultsSection) {
      this.activeResults = resultsSection
    },
    showResultsModal: function (doc) {
      this.isView = !this.isView
      if ((this.doc.lab_results < 1) || (this.doc.health_assessment_status !== 'done')) {
        this.activeResults = 'reports'
      } else if (this.doc.category === 'Prescription') {
        this.activeResults = 'reports'
      }
    },
    showFullViewModal: function (doc) {
      this.showFullView = true
      this.document = doc
      this.$emit('fullView', this.showFullView, doc)
    },
    hasHTML: function (str) {
      const doc = new DOMParser().parseFromString(str, 'text/html')
      return Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
    }
  }
}

</script>

<style scoped>
  .grid_container{
    color: #4d6189;
    display: grid;
    padding: 14px;
    grid-template-columns: 
    minmax(130px, auto) 
    minmax(90px, 100px) 
    minmax(40px, 70px)
    minmax(20px,23px)   
  }
  .btn{
    padding: 4px 0 4px 0; 
    text-align:center;
    margin: 0px 1px 0px 1px;
    align-self: center;
    cursor: pointer;
  }
  .item{
    padding: 0px;
    margin: 0px 1px 0px 1px;
    text-align: left;
    align-self: center;
  }
  ::-webkit-scrollbar {
    width: 3px;
    height: 5px;
    margin: 21px 0 12px 9px;
    border-radius: 1.5px;
    background-color: #c7cde0;
  }
</style>


// WEBPACK FOOTER //
// src/components/Customer/PatientReports.vue